// extracted by mini-css-extract-plugin
export default {"serviceSec":"service_serviceSec__KVgse","slide":"service_slide__O-MCz","serviceItam":"service_serviceItam__9pGI7"};